import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useDebouncedCallback } from 'use-debounce';
import { memo, useState } from 'react';

const SearchInput = ({
    placeholder = 'Search...',
    delay = 300,
    onSearch,
    maxWidth = 350,
    size = 'large',
}) => {
    const [value, setValue] = useState('');

    const debouncedSearch = useDebouncedCallback((val) => {
        onSearch?.(val.trim());
    }, delay);

    const handleChange = (e) => {
        const val = e.target.value;
        setValue(val);
        debouncedSearch(val);
    };

    return (
        <Input
            size={size}
            placeholder={placeholder}
            prefix={<SearchOutlined />}
            value={value}
            onChange={handleChange}
            allowClear
            style={{ maxWidth }}
        />
    );
};

export default memo(SearchInput);
